<nw-tab-group
    [selectedIndex]="selectedIndex"
    (selectedIndexChange)="selectedIndexChange($event)"
    class="article-categories__container"
>
    @for (tab of tabs; track tab; let index = $index) {
        <nw-tab [label]="tab"></nw-tab>
    }
</nw-tab-group>
